import React from 'react';
import { motion } from 'framer-motion';
interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  activeColorClassName?: string;
}
export function Switch({
  checked,
  onChange,
  label,
  activeColorClassName = 'bg-teal-600'
}: SwitchProps) {
  return <button type="button" role="switch" aria-checked={checked} aria-label={label} onClick={() => onChange(!checked)} className={`relative h-6 w-11 shrink-0 rounded-full transition-colors duration-150 ${checked ? activeColorClassName : 'bg-slate-200'}`} data-id="element-153" data-mp="2iqwxrvexsre7">
      <motion.span animate={{
      x: checked ? 20 : 0
    }} transition={{
      duration: 0.15,
      ease: [0.23, 1, 0.32, 1]
    }} className="absolute left-0.5 top-0.5 h-5 w-5 rounded-full bg-white shadow" data-id="element-154" data-mp="2wrzia3qa9tn0" />
    </button>;
}